import { Component, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';
import { Brand } from 'src/app/assabil-kernel/models/entities/control-tables/brand';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { GeoAreaExcludedPartner } from 'src/app/assabil-sales/models/dtos/geo-area-excluded-partner';


  @Component({
    selector: 'excluded-partner-widget',
    templateUrl: './excluded-partner-widget.component.html',
    styleUrls: ['./excluded-partner-widget.component.scss']
  })
  
  export class ExcludedPartnerWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    geoArea             : GeoArea;
    selectedGeoArea     : GeoArea = null;
    startDate           : Date = new Date();
    startDateDetail     : Date = new Date();
    startDateTemp       : Date = new Date();
    endDate             : Date = new Date();
    endDateDetail       : Date = new Date();
    endDateTemp         : Date = new Date();
    title               : string = "Clients exclus";
    previousPeriod      : string = "12/2030";

    geoAreaCode           : string;
    geoAreaName           : string;
    partnerclusterCode    : string;
    kpi                   : string;

    productCode         : string;
    name                : string;
    brandCode           : string;

    brands                   : Brand[];
    products                   : Product[];
    selectedBrand     : Brand = null;

    
    geoAreaExcludedPartner :  GeoAreaExcludedPartner;

    showPartnerList       : boolean = false;


    constructor(
      protected datepipe: DatePipe,
      protected specificDanoneService   : SpecificDanoneService,
      protected controlTablesService    : ControlTablesService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected controlService    : ControlTablesService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected location                : Location) {
        super(toastr, leanUtilsService);
    }
  
  //----------------------------------------------------------------------------------------------------------------------------------
  ngOnInit(){
    this.startDate.setDate(this.startDate.getDate() - 7);
    this.endDate.setDate(this.endDate.getDate() - 1);
    super.ngOnInit();
    this.controlTablesService.personGeoAreaGet().then(result => {
      this.geoArea = result;
    })

    this.controlService.getList("brand", this.controlService.getRequest()).then(result => { 
      this.brands = result;
      //console.log("brands : " + this.brands);
    })

  }
  //----------------------------------------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------------------------------------
  loadData() {
    if ( (! this.selectedGeoArea) ||   (! this.startDate) ||   (! this.endDate) || (! this.productCode && ! this.brandCode) ){
      this.toastr.error("Prière de préciser les paramètres de la recherhe");
      return;
    }

    this.geoAreaName = this.selectedGeoArea.name;
    this.geoAreaCode = this.selectedGeoArea.geoAreaCode;
    if (! this.productCode || this.productCode == "%") {
      this.productCode = "%";
      this.title = "Clients exclus du: " + this.datepipe.transform(this.startDate, 'dd/MM/yyyy') + " au: " + this.datepipe.transform(this.endDate, 'dd/MM/yyyy')  + " | " + this.selectedGeoArea.name + " | Gamme: " + this.brandCode
    } else {
      this.title = "Clients exclus du: " + this.datepipe.transform(this.startDate, 'dd/MM/yyyy') + " au: " + this.datepipe.transform(this.endDate, 'dd/MM/yyyy')  + " | " + this.selectedGeoArea.name + " | SKU: " + this.productCode
    }
    
    this.specificDanoneService.GeoAreaExcludedPartnersGet(this.startDate, this.endDate, this.geoAreaCode, this.productCode, this.brandCode).then(geoAreaExcludedPartner => {
      this.geoAreaExcludedPartner = geoAreaExcludedPartner;

  })

  }
 //----------------------------------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
click(event : any){
  this.partnerclusterCode      = event.partnerclusterCode;
  this.geoAreaCode             = event.geoArea.geoAreaCode;
  this.kpi                     = event.kpi;
  this.startDateDetail         = this.startDate;
  this.endDateDetail           = this.endDate;
  this.showPartnerList         = true;
}
//--------------------------------------------------------------------------------------------------------


  selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }

  
  selectBrand(){
    //console.log("brandCode : " + this.brandCode);
    
    this.masterDataService.productsGet(null, null, null, this.brandCode, true, false, false, null).then(result => {
      this.products = result;
      //console.log("products : " + this.products);
  });
  
  
  }
  
//----------------------------------------------------------------------


//--------------------------------------------------------------------------------------
returnBack(){
  this.location.back();
}
//--------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------
  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  